import * as React from "react";
import { getHoverableTooltipsPreference } from "@1js/acui-common";
import type { AppTooltipProps } from "../Next";
import { tooltipTextFormatter } from "../utilities/tooltipTextFormatter";

export const useConvertTooltipContent = (
  props: AppTooltipProps,
  setVisible?: (visible: boolean) => void
): React.ReactElement => {
  const { tooltipLabel } = props;
  const hoverablePreference: boolean = getHoverableTooltipsPreference();
  const tooltipRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    if (tooltipRef.current) {
      // eslint-disable-next-line @microsoft/sdl/no-inner-html
      tooltipRef.current.innerHTML = tooltipTextFormatter(tooltipLabel ?? "");
    }
  });
  return (
    <div
      onMouseEnter={() => {
        setVisible?.(hoverablePreference);
      }}
      ref={tooltipRef}
    />
  );
};
